
//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.TeamFoundation.Server.WebAccess.ProjectOverview.Plugins
//----------------------------------------------------------


export module ActivityPaneSecurityConstants {
    export var NamespaceId = "dc02bf3d-cd48-46c3-8a41-345094ecc94b";
    export var Token = "/UserIsValid";
    export var GenericRead = 1;
}

export module ProjectOverviewCIConstants {
    export var Area = "ProjectOverviewPage";
    export var Layer = "DataProvider";
}

export module ProjectOverviewConstants {
    export var ProjectTags_Separators = [",", ";"];
    export var ProjectTags_InvalidCharacters = ["/"];
    export var ProjectTags_InvalidLastCharacters = ["-"];
    export var ProjectTags_InvalidLastCharactersRegex = ".*-$";
    export var ProjectOverviewData = "projectOverviewData";
    export var Scope = "scope";
    export var ProjectId = "projectId";
    export var ProjectHasCodeRegistryPath = "ProjectOverview/HasCode";
    export var ProjectHasWorkItemsRegistryPath = "ProjectOverview/HasWorkItems";
    export var ProjectHasBuildDefinitionsRegistryPath = "ProjectOverview/HasBuildDefinitions";
    export var ProjectHasReleaseDefinitionsRegistryPath = "ProjectOverview/HasReleaseDefinitions";
    export var ImageIdProperty = "Microsoft.TeamFoundation.Identity.Image.Id";
    export var ProjectDefaultRepoRegistryPath = "VersionControl/ProjectOverview/DefaultRepository";
    export var ReadmeFilePath = "/README.md";
    export var ReadmeFileName = "README.md";
    export var WikiHomePage = "WikiHomePage";
    export var TfvcMetrics = "tfvcmetrics";
    export var CodeMetrics = "codemetrics";
    export var GitMetrics = "gitmetrics";
    export var NumOfDays = "numOfDays";
    export var ProjectLanguageMetrics = "projectlanguagemetrics";
    export var WorkMetrics = "workmetrics";
    export var WorkMetrics_MaxCountLabel = "maxcount";
    export var WorkMetrics_MaxCountDefaultValue = 1000;
    export var UpsellSectionData = "upsellSectionData";
    export var DismissedUpsellPath = "ProjectOverview/UpsellsDismissedOptions";
    export var ProjectMembers_MembersRegistryPath = "ProjectOverview/Members/Details";
    export var ProjectMembers_ForceRefreshMembers = "forceRefresh";
    export var ProjectMembers_MaxDisplayCount = 8;
    export var ProjectMembers_MaxCount = 100;
    export var AllProjectTags = "allprojecttags";
    export var ProjectTagsPropertyPrefix = "Microsoft.TeamFoundation.Project.Tag.";
    export var ProjectTag_CharacterLimit = 40;
    export var ProjectTags_MaxCount = 15;
}

